import { jwtDecode } from 'jwt-decode'
import React, { useState, useEffect, useRef } from 'react'
import { useMediaQuery } from 'react-responsive'

import checkCircle from '../../../icones/check-circle-escuro.svg'
import disableCircle from '../../../icones/disable-circle-claro-sem-opacidade.svg'
import erroCircle from '../../../icones/erro-cirle-escuro.svg'
import alertIcon from '../../../icones/iconesVersaoEscura/alert.svg'
import outlinedCircleEscuro from '../../../icones/outlined-circle.svg'
import { UserTrialSimcardsService } from '../../../services/http/userTrialSimcards.service.js'
import { useGlobal } from '../../../stores/useGlobal.js'
import { logoVeye } from '../../../utils/alternanciaIcones.js'
import BlankSlate from '../../BlankSlate/index.jsx'
import ScrollArea from '../../Mantine/ScrollArea'

import background from './image/background.jpg'
import * as S2 from './responsiveStyle.js'
import * as S from './styles.js'


const config = require('../../../configuracoes.json')
const { recaptcha } = config

export function validateJwtToken(token) {
  try {
    return jwtDecode(token)
  } catch (error) {
    return null
  }
}

const REGEX_MIN_CARACTERES = /^.{8,}$/
const REGEX_MAIUSCULAS = /[A-Z]/
const REGEX_MINUSCULAS = /[a-z]/
const REGEX_NUMEROS = /[0-9]/
const REGEX_CARACTERES_ESPECIAIS = /[!@#$%^&*()_+{}[\]:;,.?~\-|<>=]/

const token = window.location?.search?.split('token:')[1]
const data = validateJwtToken(token)

const PasswordForm = ({
  formData,
  handleCodeChange,
  handlePasswordChange,
  handleConfirmPasswordChange,
  handleSubmit,
  codeError,
  getIcon,
  recaptchaRef,
  disableConfirm,
  isIOS
}) => {
  return (
    <>
      <S.Box>
        {data && (
          <>
            <div className="container-title">
              <S.Title fontSize="60px">Bem vindo(a) ao V.EYE!</S.Title>

              <S.Paragraph>
                <b>
                  Insira abaixo seu código promocional e crie uma senha para
                  acessar a plataforma V.EYE e ativar seus SIM cards.
                </b>
              </S.Paragraph>

              <S.Span>
                Em caso de dúvidas, entre em contato pelo <br />
                telefone/WhatsApp: (51) 3562-1777 <br />
                ou e-mail: duvidas.simcardevento@virtueyes.com.br
              </S.Span>
            </div>

            <S.Form
              autocomplete="off"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <input
                type="text"
                name="fake_username"
                autoComplete="username"
                style={{ display: 'none' }}
              />
              <input
                type="password"
                name="fake_password"
                autoComplete="new-password"
                style={{ display: 'none' }}
              />
              <S.Input
                radius="xl"
                placeholder="Seu código promocional"
                value={formData.code}
                onChange={handleCodeChange}
                error={codeError}
                maxLength={10}
              />
              <S.PasswordInput
                radius="xl"
                placeholder="Nova senha"
                value={formData.password}
                onChange={handlePasswordChange}
                maxLength={64}
              />
              <S.PasswordInput
                radius="xl"
                placeholder="Confirme nova senha"
                value={formData.confirmPassword}
                onChange={handleConfirmPasswordChange}
                maxLength={64}
              />

              <div
                style={{ marginBottom: isIOS ? '10px' : '0' }}
                className="g-recaptcha"
                data-sitekey={recaptcha.siteKey}
                data-callback="onRecaptchaSuccess"
                ref={recaptchaRef}
               />
              <S.MensagensErroWrapper>
                <S.TituloMensagem>A nova senha deve conter:</S.TituloMensagem>
                <S.ValidacoesWrapper>
                  <S.GrupoValidacao>
                    <img alt="min_char" src={getIcon('faltaMinChar')} />
                    Entre 8 e 20 caracteres;
                  </S.GrupoValidacao>
                  <S.GrupoValidacao>
                    <img alt="grupos" src={getIcon('faltaMinGrupo')} />
                    <p>
                      {' '}
                      Uso de pelo menos três dos quatro grupos de caracteres:
                    </p>
                  </S.GrupoValidacao>
                  <S.GrupoValidacao subGrupo>
                    <img alt="maiusculo" src={getIcon('faltaMaiuscula')} />
                    <p>Letras maiúsculas (A-Z)</p>
                  </S.GrupoValidacao>
                  <S.GrupoValidacao subGrupo>
                    <img alt="minusculo" src={getIcon('faltaMinuscula')} />
                    <p>Letras minúsculas (a-z)</p>
                  </S.GrupoValidacao>
                  <S.GrupoValidacao subGrupo>
                    <img alt="numero" src={getIcon('faltaNumero')} />
                    <p>Números (0-9)</p>
                  </S.GrupoValidacao>
                  <S.GrupoValidacao subGrupo>
                    <img alt="char_especiais" src={getIcon('faltaEspecial')} />
                    <p>Caracteres especiais (ex.: !@#$%^&*)</p>
                  </S.GrupoValidacao>
                  <S.GrupoValidacao>
                    <img alt="senha_iguais" src={getIcon('senhaDiferente')} />
                    <p>As senhas devem ser iguais.</p>
                  </S.GrupoValidacao>
                </S.ValidacoesWrapper>
              </S.MensagensErroWrapper>

              <S.Group position="center" mt="md">
                <S.Button
                  radius="xl"
                  fullWidth
                  type="submit"
                  disabled={disableConfirm}
                >
                  Concluir
                </S.Button>
              </S.Group>
            </S.Form>
          </>
        )}
        {!data && (
          <S.BlankSlateContainer notHasData={!data}>
            <BlankSlate
              size="md"
              icon={alertIcon}
              title="Link não encontrado"
              subTitle="Este link foi excluído ou o URL é inválido."
              color="#000"
            />
          </S.BlankSlateContainer>
        )}
      </S.Box>
    </>
  )
}

export default function LoginActivation() {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  document.addEventListener('DOMContentLoaded', () => {
    const chatBtn = document.querySelector('.smk-altu-button-chat')

    chatBtn.style.display = 'none'
    chatBtn.style.opacity = '0'
  })

  const { postUser } = UserTrialSimcardsService
  const { setIsLoadingGlobal, setMostrarNotificacao } = useGlobal()
  const recaptchaRef = useRef()
  const [codeError, setCodeError] = useState('')
  const [recaptchaToken, setRecaptchaToken] = useState(null)

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
    code: ''
  })

  const isMobile = useMediaQuery({ maxWidth: 829 })

  const [erro, setErro] = useState({
    faltaMaiuscula: false,
    faltaMinuscula: false,
    faltaNumero: false,
    faltaMinChar: false,
    faltaEspecial: false,
    faltaMinGrupo: false,
    senhaDiferente: false,
    senhaIgualAnterior: false,
    senhaAtualInvalida: false
  })

  const disableConfirm =
    erro.faltaMinGrupo ||
    erro.faltaMinChar ||
    erro.senhaDiferente ||
    erro.senhaIgualAnterior ||
    formData.code?.length <= 5

  const handlePasswordChange = (event) => {
    setCodeError('')
    const value = event.target.value
    setFormData((prev) => ({ ...prev, password: value }))
  }

  const handleCodeChange = (event) => {
    const value = event.target.value
    setFormData((prev) => ({ ...prev, code: value }))
  }

  const validateCode = (value, forceError = false, message = '') => {
    if (forceError) return message
    else if (value?.length <= 5) {
      return 'Código promocional inválido!'
    }
    return ''
  }

  const handleConfirmPasswordChange = (event) => {
    const value = event.target.value
    setFormData((prev) => ({ ...prev, confirmPassword: value }))
  }

  const getIcon = (type) => {
    const campos = [
      'faltaMaiuscula',
      'faltaMinuscula',
      'faltaNumero',
      'faltaEspecial'
    ]

    const isAllErro =
      erro.faltaMinGrupo &&
      erro.faltaMaiuscula &&
      erro.faltaMinuscula &&
      erro.faltaNumero &&
      erro.faltaEspecial &&
      erro.senhaDiferente

    if (isAllErro && campos.includes(type)) return outlinedCircleEscuro

    if (erro[type]) {
      if (!erro.faltaMinGrupo && campos.includes(type)) {
        return disableCircle
      }

      return erroCircle
    }

    return checkCircle
  }

  const validarSenhaComGrupos = (password) => {
    let gruposValidos = 0

    if (REGEX_MAIUSCULAS.test(password)) gruposValidos++
    if (REGEX_MINUSCULAS.test(password)) gruposValidos++
    if (REGEX_NUMEROS.test(password)) gruposValidos++
    if (REGEX_CARACTERES_ESPECIAIS.test(password)) gruposValidos++

    return gruposValidos >= 3
  }

  useEffect(() => {
    const validarSenha = () => {
      const faltaMinChar = !REGEX_MIN_CARACTERES.test(formData.password)
      const faltaMaiuscula = !REGEX_MAIUSCULAS.test(formData.password)
      const faltaMinuscula = !REGEX_MINUSCULAS.test(formData.password)
      const faltaNumero = !REGEX_NUMEROS.test(formData.password)
      const faltaEspecial = !REGEX_CARACTERES_ESPECIAIS.test(formData.password)
      const faltaMinGrupo = !validarSenhaComGrupos(formData.password)
      const senhaDiferente = !(
        formData.password && formData.password === formData.confirmPassword
      )

      setErro((prev) => ({
        ...prev,
        faltaMinChar,
        faltaMaiuscula,
        faltaMinuscula,
        faltaNumero,
        faltaEspecial,
        faltaMinGrupo,
        senhaDiferente
      }))
    }

    validarSenha()
  }, [formData.password, formData.confirmPassword])

  useEffect(() => {
    const scriptId = 'recaptcha-script'

    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script')
      script.src = 'https://www.google.com/recaptcha/api.js'
      script.async = true
      script.defer = true
      script.id = scriptId

      if (isIOS) document.body.classList.add('is-ios')
      document.body.appendChild(script)
    }

    window.onRecaptchaSuccess = (token) => {
      setRecaptchaToken(token)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault()

    const codeValdiation = validateCode(formData.code)
    setCodeError(codeValdiation)

    if (codeValdiation) return

    if (!recaptchaToken) {
      setMostrarNotificacao({
        show: true,
        type: 'error',
        autoHide: 5000,
        title: 'ReCAPTCHA',
        message: 'Marque o campo de reCAPTCHA para continuar'
      })
      return
    }

    const dataForm = {
      ...data,
      ds_token: recaptchaToken,
      ds_nome: data.ds_pav_cliente,
      ds_senha: formData.password,
      ds_codigo: formData.code
    }

    setIsLoadingGlobal(true)
    try {
      await postUser(dataForm)
      login()
    } catch (error) {
      const { message } = error

      setMostrarNotificacao({
        show: true,
        type: 'error',
        autoHide: 5000,
        title: 'Falha ao cadastrar usuário',
        message: message || 'Erro ao validar reCAPTCHA'
      })

      if (message === 'Código inválido!') {
        setCodeError(
          validateCode(formData.code, true, 'Código promocional inválido!')
        )
      }

      console.error('Error:', error)
    } finally {
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        window.grecaptcha.enterprise.reset()
      }
      setRecaptchaToken(null)
      setIsLoadingGlobal(false)
    }
  }

  const login = () => {
    window.location.href = `${window.location.origin}/login`
  }

  return (
    <S2.Container>
      <S.HeaderWrapper>
        <S.Header>
          <img className="logoVeye" src={logoVeye()} alt="V.eye" />
          <div className="texto-logo">Gestão inteligente de conectividade</div>
        </S.Header>
      </S.HeaderWrapper>

      <S2.Main>
        {isMobile && (
          <ScrollArea type="always" height="100vh">
            <S.ContainerFormMobile>
              <PasswordForm
                formData={formData}
                handleCodeChange={handleCodeChange}
                handlePasswordChange={handlePasswordChange}
                handleConfirmPasswordChange={handleConfirmPasswordChange}
                handleSubmit={handleSubmit}
                codeError={codeError}
                getIcon={getIcon}
                recaptchaRef={recaptchaRef}
                disableConfirm={disableConfirm}
                setRecaptchaToken={setRecaptchaToken}
                isIOS={isIOS}
              />
            </S.ContainerFormMobile>
          </ScrollArea>
        )}
        {!isMobile && (
          <>
            <S2.Division>
              <S2.Image src={background} alt="Background" />
            </S2.Division>

            <S2.Division2>
              <S2.Data>
                <S.ContainerForm>
                  <PasswordForm
                    formData={formData}
                    handleCodeChange={handleCodeChange}
                    handlePasswordChange={handlePasswordChange}
                    handleConfirmPasswordChange={handleConfirmPasswordChange}
                    handleSubmit={handleSubmit}
                    codeError={codeError}
                    getIcon={getIcon}
                    recaptchaRef={recaptchaRef}
                    disableConfirm={disableConfirm}
                    setRecaptchaToken={setRecaptchaToken}
                    isIOS={isIOS}
                  />
                </S.ContainerForm>
              </S2.Data>
              <svg
                width="100%"
                height="100%"
                style={{ position: 'absolute', top: 0, left: 0 }}
              >
                <defs>
                  <clipPath id="clip-shape" clipPathUnits="objectBoundingBox">
                    <path d="M0.1075 0.43 C0.1866 0.1278, 0.2364 0, 0.2364 0 H1 V1 H0 C0.0285 0.73, 0.1075 0.43, 0.1075 0.43 Z" />
                  </clipPath>
                </defs>
              </svg>
            </S2.Division2>
          </>
        )}
      </S2.Main>
    </S2.Container>
  )
}
